import {signalRHubFactory} from '../../../app/vendors/signalRHubFactory';

export const biotwinHub = signalRHubFactory({name: 'biotypeHub'});
